import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { Settings } from "../../../helpers/Contexts";
import { MdClose, MdCheck } from "react-icons/md";

import FieldError from "../../../shared/FieldError";

const StatinTherapy = ({ data, handleField }) => {
  const StatinTherapy = Yup.object().shape({
    data: Yup.string().nullable(),
  });

  return (
    <div>
      <Formik
        initialValues={{
          data: data.value,
        }}
        validationSchema={StatinTherapy}
        validateOnChange={true}
        onSubmit={async (values) =>
          await handleField({
            id: data.id,
            value: values.data,
            cpr_id: data.cprId,
            quality_measurement_type_id: data.quality_measurement_type_id,
          })
        }
      >
        {({ values, errors, setFieldValue, initialValues }) => {
          return (
            <Form>
              {" "}
              <label>
                Statin Therapy <span id="from">(type of statin being used by patient)</span>
              </label>
              <input
                className="default"
                placeholder="e.g. Simvastatin"
                value={values.data}
                onChange={(e) => setFieldValue("data", e.target.value)}
              />
              {initialValues.data !== values.data && !errors.data && (
                <div className="check-cancel-buttons flex">
                  <button className="check small" type="submit">
                    <MdCheck className="check-icon" />
                  </button>
                  <button
                    className="cancel small"
                    onClick={() => {
                      initialValues.data
                        ? setFieldValue("data", initialValues.data)
                        : setFieldValue("data", "");
                    }}
                  >
                    <MdClose className="cancel-icon" />
                  </button>
                </div>
              )}
              {errors.data ? <FieldError error={errors.data} /> : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default StatinTherapy;
